/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react';
import {Navigate, Outlet, Route, Routes} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import LoginOTPAuth from './components/OTPAuth/LoginOTPAuthLayout';

const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-white');
    return () => {
      document.body.classList.remove('bg-white');
    };
  }, []);

  return (
    <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
      {/* begin::Content */}
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* begin::Logo */}
        <a href='#' className='mb-12'>
          <img
            alt='Logo'
            src={toAbsoluteUrl('/media/logos/mecanizou-logo.svg')}
            className='h-45px'
          />
        </a>
        {/* end::Logo */}
        {/* begin::Wrapper */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Outlet />
        </div>
        {/* end::Wrapper */}
      </div>
      {/* end::Content */}
    </div>
  );
};

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<LoginOTPAuth />} />
      <Route index element={<LoginOTPAuth />} />
      <Route path='*' element={<Navigate to='/auth/login' replace />} />
    </Route>
  </Routes>
);

export {AuthPage};
